module.exports = __webpack_public_path__ + "static/media/ag-products7.230a4aaf.jpg";